export default __webpack_public_path__ + "static/media/white-ag-planet.5c94ebb8.png";